




interface HeaderLine extends HTMLElement {
    titleElem: HTMLElement;
}





class HeaderLine extends HTMLElement {

    constructor () {
        super();

        this.titleElem = this.parentElement.querySelector('.title');

        this.setupLineWidth();
        window.addEventListener('resize', () => this.setupLineWidth());
    }

    setupLineWidth () {
        const clientRects = this.titleElem.getClientRects();
        const gap = 20;
        let lineWidth = 0;

        if ( this.parentElement.parentElement.nextElementSibling === null ) {
            const clientRect = clientRects[0];

            this.style.marginTop = `${clientRect.height * 0.55}px`;
            this.style.right = `${clientRect.width + gap}px`;

            const parentLeft = this.parentElement.parentElement.getBoundingClientRect().left;
            lineWidth = clientRect.left - parentLeft + 80;
        } else {
            const clientRect = clientRects[clientRects.length - 1];

            const holderWidth = this.parentElement.getBoundingClientRect().width;
            const titleWidth = clientRect.width;

            lineWidth = holderWidth - titleWidth - gap;
        }

        if ( lineWidth < 0 ) {
            lineWidth = 0;
        }

        this.style.width = `${lineWidth}px`;
    }
}



export function setupHeaderLine () {
    customElements.define('header-line', HeaderLine);
}
